import React from 'react';
import { Link } from 'react-router-dom';
import { SectionLabel } from '@/components/site/SectionLabel';
import { LEGAL } from '@/data/legal';

const OTHER = {
  policy: { to: LEGAL.tos.path, label: 'Terms of Service' },
  tos: { to: LEGAL.policy.path, label: 'Privacy Policy' },
};

export default function Legal({ doc }) {
  const page = LEGAL[doc];
  const other = OTHER[doc];

  return (
    <div data-testid={`${doc}-page`}>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-50 pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 md:pt-40 pb-14 md:pb-20">
          <SectionLabel as="h1" num="01" data-testid={`${doc}-eyebrow`}>
            {page.eyebrow}
          </SectionLabel>
          <p className="mt-8 text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tightest leading-[1.05] text-balance max-w-4xl">
            {page.headline}
          </p>
          <p className="mt-8 text-[11px] uppercase tracking-[0.28em] text-ink-muted">
            Last updated · {page.updated}
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24 md:pb-32">
        <div className="max-w-3xl">
          <p className="text-lg md:text-xl text-ink-text/90 leading-relaxed">{page.intro}</p>

          <div className="mt-14 border-t border-white/10">
            {page.sections.map((s, i) => (
              <div key={s.title} className="py-10 border-b border-white/10">
                <h2 className="flex items-baseline gap-4 text-xl md:text-2xl font-bold tracking-tight">
                  <span aria-hidden className="text-xs font-normal tabular-nums text-ink-muted">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  {s.title}
                </h2>
                <div className="mt-5 space-y-4 text-ink-muted leading-relaxed">
                  {s.body.map((block, j) =>
                    Array.isArray(block) ? (
                      <ul key={j} className="space-y-2.5 pl-5 list-disc marker:text-violet">
                        {block.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <p key={j}>{block}</p>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>

          <p className="mt-10 text-sm text-ink-muted">
            See also our{' '}
            <Link to={other.to} className="text-white underline underline-offset-4 hover:text-violet">
              {other.label}
            </Link>
            .
          </p>
        </div>
      </section>
    </div>
  );
}
